import ApiBase from './ApiBase';
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import moment from 'moment';

/**
 * Log API
 */
class LogApi extends ApiBase {
  async sendClientlogs(payload) {
    const request = {
      url: `${this.API_URL}/jslogs`,
      headers: this.getHeaders(),
      method: 'POST',
      data: JSON.stringify(payload)
    };

    const response = await axios.request(request);
    return response.status;
  }

  createTrackingObject(
    logId,
    level,
    message,
    time,
    stacktrace,
    location,
    tags
  ) {
    return [
      {
        logId: logId ? logId : uuidv4(),
        level: level ? level : 'TRACE',
        message: message ? message : '',
        time: time ? time : moment().toISOString(),
        stacktrace: stacktrace ? stacktrace : '',
        location: location ? location : '',
        tags: tags ? tags : ''
      }
    ];
  }
}

export default new LogApi();
